<div class="row">
  <div class="col-xl-10">
    @if (summaryItems && !fromSalesOrder) {
      <div class="mb-3">
        <app-summary [model$]="model$" [summaryItems]="summaryItems.bind(this)"></app-summary>
      </div>
    }
  </div>
  <div class="col-xl-2">
    @if (productDetails) {
      <app-product-logo [product]="productDetails" [showBrowse]="false" [showRemove]="false"></app-product-logo>
    }
  </div>
</div>

<app-grid
  stateKey="SalesOrderLineStockAllocations"
  [gridCssClass]="gridCssClass"
  [header]="header"
  [columnDefs]="columnDefs"
  [rowData]="stockItems$ | async"
  [showDelete]="false"
  [pagination]="false"
  (rowSelected)="rowSelected($event)"
></app-grid>
